export const errorCodeMapping = {
  10077: "ERROR_MISSING_REQUIRED_PARAMETER_10077",
  10056: "ERROR_INVALID_PHONE_NUMBER",
  10112: "ERROR_INVALID_REQUEST_10112",
  10115: "ERROR_INTERNAL_FAILURE_10115",
  10116: "ERROR_CART_NOT_FOUND_10116",
  10117: "ERROR_USER_NOT_FOUND_10117",
  10118: "ERROR_FAILED_CREATING_CONTRACT_10118",
  10126: "ERROR_FINANCED_AMOUNT_OUT_OF_RANGE_10126",
  10132: "ERROR_PHONE_NUMBER_ALREADY_IN_USE",
  10141: "ERROR_NO_DEVICE_FOUND_10141",
  10150: "ERROR_CUSTOMER_HAS_NOT_AGREED_TO_TERMS_10150",
  10154: "ERROR_DEVICE_SIM_NUMBER_MISSING_10154",
  10159: "ERROR_MERCHANT_IS_UNKNOW_10159",
  10160: "ERROR_MERCHANT_IS_CLOSED_10160",
  10165: "ERROR_DEVICE_ALREADY_FINANCED_10165",
  10178: "ERROR_MERCHANT_IS_OUTSIDE_COUNTRY_10178",
  10179: "ERROR_NO_PAYMENT_INFO_FOR_DEVICE_10179",
  10182: "ERROR_UNRECOGNIZED_PAYMENT_OPTION_10182",
  10188: "ERROR_MERCHANT_CANNOT_TAKE_SIMULTANEOUS_LOAN_LINE_PAYMENT_10188",
  10191: "ERROR_CUSTOMER_HAS_OUTSTANDING_ACCOUNTS_10191",
  10193: "ERROR_ZERO_TOUCH_CLAIM_FAILED_10193",
  10199: "ERROR_INVALID_DEVICE_MANAGER_FOR_DEVICE_10199",
  10207: "ERROR_INVALID_CREDENTIALS_10207",
  10212: "CUSTOMER_HAS_ACTIVE_FINANCE_ORDER",
  10225: "API_PHONE_NUMBER_ALREADY_IN_USE",
  10230: "ERROR_DEVICE_NOT_MATTCH_OFFER_10230",
  10232: "ERROR_FINANCE_PERCENT_TOO_LARGE_10232",
  10244: "ERROR_INVALID_PIN",
  10246: "ERROR_NO_DEVICE_FOR_PHONE_NUMBER_10246",
  10247: "ERROR_EMAIL_ALREADY_IN_USE",
  10252: "ERROR_PRICE_AMOUNT_OUT_OF_RANGE_10252",
  10253: "ERROR_DOWNPAYMENT_AMOUNT_OUT_OF_RANGE_10253",
  10275: "ERROR_CLERK_LOGIN_TO_WRONG_MERCHANT_10275",
  10391: "INVALID_CREDIT_LINE_STATUS_PLEASE_REVIEW",
  10392: "NOT_ENOUGH_CREDIT_ON_CREDIT_LINE",
  10393: "CREDIT_LIMIT_EXCEEDED_SELECT_DIFFERENT_DEVICE",
  10403: "ERROR_DEVICE_ATTACHED_TO_CREDIT_LINE_10403",
  10432: "ERROR_ADMIN_MISSING_BANK_DETAILS",
  10434: "ERROR_DEVICE_IMEI_DOES_NOT_MATCH_CART_10434",
  10445: "ERROR_UNKNOWN_POSTAL_CODE_10445",
  10376: "ERROR_CREDIT_LINE_NOT_FOUND",
  10449: "ERROR_PAYMENT_AMOUNT_OUT_OF_RANGE",
  10450: "DEVICE_LOAN_ALREADY_FULLY_PAID",
  10467: "ERROR_ACCESSORY_BUNDLE_PRICE_OUT_OF_RANGE",
  10317: "SELF_ONBOARDING.ERRORS.USER_NO_CART",
  10318: "SELF_ONBOARDING.ERRORS.ID_NUMBER_INVALID",
  10319: "SELF_ONBOARDING.ERRORS.MERCHANT_INVALID",
  10316: "SELF_ONBOARDING.ERRORS.SEARCH_FAILED",
  10486: "EVERTEC_VOUCHER_IS_ALREADY_CREATED_ERROR",
  10487: "EVERTEC_VOUCHER_AMOUNT_DOES_NOT_MATCH_ERROR",
  10478: "ERROR_CANCELED_CART",
  10485: "ERROR_VIRTUAL_VOUCHER_ALREADY_REDEEMED",
  10503: "ERROR_FINANCED_AMOUNT_OUT_OF_RANGE_CANT_GIVE_OFFER",
  10006: "AC.CREATE_MERCHANT.MERCHANT_CREATION_FAILED",
  10007: "AC.CREATE_MERCHANT.MERCHANT_NAME_ALREADY_EXISTS",
  10008: "AC.DOCUMENTS.FILE_UPLOAD_ERROR",
  10009: "AC.DOCUMENTS.FILE_SIZE_EXCEEDED",
  10010: "AC.DOCUMENTS.FILE_TYPE_NOT_ALLOWED",
  10202: "NOT_ELIGIBLE_FOR_KG_ENROLLMENT",
  10203: "INVALID_HARDWARE_IDENTIFIER_KG",
  10205: "ERROR_KG_ENROLLMENT_ERROR_UNKNOWN",
  10370: "ERROR_KG_NO_LICENSE",
  10371: "ERROR_KG_ALREADY_ENROLLED",
  10372: "ERROR_KG_CREATE_PRECLAIM",
  10373: "ERROR_KG_ENROLL_FAIL_APPROVE_ID",
  10501: "ERROR_KG_ENROLL_MUST_USE_IMEI_1",
  10502: "TEMPORARY_KG_ENROLLMENT_PROBLEM",
  10520: "ERROR_ECOMMERCE_DOWN_PAYMENT_COMPLETED",
  10521: "ERROR_ECOMMERCE_DOWN_PAYMENT_IN_PROGRESS",
  10534: "CART_DOCUMENT_FILES.ERROR_FILE_TYPE_NOT_SUPPORTED",
  10535: "CART_DOCUMENT_FILES.ERROR_FILE_SIZE_EXCEEDED",
  10536: "CART_VERIFICATION.ERROR_INVALID_OTP_AUTHORIZATION_CODE",
  10540: "ERROR_TRUSTONIC_TIMEOUT_10540",
  10549: "CART_VERIFICATION.ERROR_UNKNOWN_PARTNER_VERIFICATION_SCHEMA",
  10550: "ERROR_INVALID_PARAMETER_LENGTH",
  10551: "ERROR_INVALID_PARAMETER_FORMAT",
  10552: "ERROR_INVALID_PARAMETER_TYPE",
  10553: "ERROR_INVALID_PARAMETER_MIN_VALUE",
  10558: "ERROR_NOT_THE_LATEST_CART",
  10568: "ERROR_PHONE_NUMBER_REQUIRED_BY_PERSONS",
  10581: "KG_DEVICE_STATE_PROBLEM",
  10589: "ERROR_DEVICE_VARIANT_MISMATCH",
};
